import api from './api';
import { API_COMMANDS } from './commands';

const requestSmsCode = async (phoneNumber, registration = false, captchaToken = null) => {
  const body = { phone: phoneNumber, registration };
  if (captchaToken) {
    body.captcha_token = captchaToken;
  }
  const response = await api.post('', body, {
    params: { command: API_COMMANDS.AUTH_REQUEST_CODE },
  });
  return response.data;
};

const confirmCode = async (id, code) => {
  const response = await api.post(
    '',
    { id, code },
    {
      params: { command: API_COMMANDS.AUTH_CONFIRM_CODE },
    }
  );
  return response.data;
};

const logoutApi = async () => {
  const response = await api.post(
    '',
    {},
    {
      params: { command: API_COMMANDS.AUTH_LOGOUT },
    }
  );
  return response.data;
};

export { confirmCode, logoutApi, requestSmsCode };
